export const getQuartersUpToQuarter = (quarter: number): number[] => {
  if (quarter < 1 || quarter > 4) {
    return []
  }

  return Array.from({ length: quarter }, (_, index) => index + 1)
}
